class NotesFormatter {
  static formattedData(response, app) {

    let data = [];
    $.each(response, function (stepIndex, post) {
      data.push(NotesFormatter.prepareRow(post, app));
    });
    return {'notes': data};
  }

  static prepareRow(post, app) {
    let additionalData = {};
    const userTimeZone = app.apis.user.get().timezone;
    post.log_time = moment(post.d).tz(userTimeZone).format('ddd Do MMM h:mm a');
    return {...post, ...additionalData};
  }
}

class HistoryFormatter {
  static formattedData(response, app) {

    let data = [];
    $.each(response, function (stepIndex, post) {
      data.push(HistoryFormatter.prepareRow(post, app));
    });
    return {'logs': data};
  }

  static prepareRow(post, app) {
    let additionalData = {};
    const networkParts = post.network.split('--');
    const [socialKey, , pagePart1, pagePart2] = networkParts[0].split('::').map(part => $.trim(part));

    // Define social network mappings
    const socialMappings = {
      'linkedin': 'LinkedIn',
      'fbg': 'Facebook Group',
      'gmb': 'Google Business Page'
    };

    let social = socialMappings[socialKey] || socialKey;
    let page = socialKey === 'linkedin' ? `${pagePart1} :: ${pagePart2}` : pagePart1;

    additionalData.network = `${social} (${page})`;
    additionalData.social = `${social}`;
    additionalData.socialIcon = {
      fbg: 'facebook-f',
      gmb: 'google',
      twitter: 'x-twitter'
    }[social.trim()] || social.trim();
    additionalData.socialIcon = additionalData.socialIcon.toLowerCase();
    additionalData.page = `${page}`;
    const userTimeZone = app.apis.user.get().timezone;
    post.postTime = moment.utc(post.postDate).tz(userTimeZone);
    post.postTime = post.postTime.format('MM/DD/YYYY hh:mm A');

    if (Utils.isJsonString(post.error)) {
      try {
        post.error = Utils.decodeEntities(post.error);
        let errorObj = _.isEmpty(post.error) ? {} : JSON.parse(post.error);
        let errorMessage = '';

        if (!app.isEmpty(errorObj['message'])) {
          errorMessage = errorObj['message'];

          if (Utils.isJsonString(errorMessage)) {
            errorMessage = JSON.parse(errorMessage);
            errorObj = errorMessage;
          }
        }

        if (!app.isEmpty(errorObj['posts'])) {
          errorObj = errorObj['posts'][0];
        }

        if (!app.isEmpty(errorObj['errors'])) {
          errorMessage = !app.isEmpty(errorObj['errors'][0]['message']) ? errorObj['errors'][0]['message'] : '';
        }
        post.error = errorMessage;

      } catch (e) {
        post.error = e.toString();
      }
    }

    return {...post, ...additionalData};
  }
}

class PostFormatter {

  static DATE_IN_PAST = 'Date in Past';
  static UN_SCHEDULED = 'Un Scheduled';

  static getPostStatus(event, baseStatus) {
    if (!event.approvedStatus) {
      return baseStatus;
    }

    switch (event.approvedStatus) {
      case 'unapproved':
        return baseStatus !== this.DATE_IN_PAST ? 'Not Approved' : baseStatus;
      case 'approved':
        return baseStatus === this.UN_SCHEDULED ? 'Approved & Un Scheduled' :
            baseStatus === 'Scheduled' ? 'Approved & Scheduled' : baseStatus;
      case 'review':
        return 'In Review';
      case 'pending-review':
        return baseStatus === this.UN_SCHEDULED ? ' In Draft/Review' : baseStatus;
      default:
        return baseStatus;
    }
  }

  static formatPostTime(event, userTimeZone) {
    return this.formatTime(event.d, userTimeZone);
  }

  static formatTime(postTime, userTimeZone) {
    postTime = moment(postTime).tz(userTimeZone);

    // Get the current date in 'YYYY-MM-DD' format
    const currentDate = new Date().toISOString().split('T')[0];
    const postDate = postTime.format('YYYY-MM-DD');

    return {
      isCurrentDay: currentDate === postDate,
      postTimeCalendar: postTime.format('YYYY-MM-DDTHH:mm:ss'),
      postDay: postTime.format('YYYY-MM-DD'),
      postDayTime: postTime.format(' h:mm a'),
      postEditorTime: postTime.format('MM/DD/YYYY hh:mm A'),
      postDate: postTime.format('ddd Do MMM h:mm a'),
      postTimeDisplay: postTime.format(' h:mm ') + '<span>' + postTime.format('A') + '</span>',
    };
  }

  static formatNetworks(eventNetworks) {
    const networks = {};

    eventNetworks.forEach(network => {
      const [networkInfo, status, ...rest] = network.split('--');
      const [social, , pageName] = networkInfo.split('::');
      const postUrl = rest.join('--').trim();
      const icon = {fbg: 'facebook-f', gmb: 'google', twitter: 'x-twitter'}[social.trim()] || social.trim();
      const page = social === 'linkedin' ? `${pageName} :: ${rest[0]}` : pageName;

      networks[social] = networks[social] || [];
      networks[social].push({network: social, icon, status, 'post-url': postUrl, page});
    });

    return networks;
  }

  static getStatusBadge(app, formattedEvent) {
    const statusClass = app.isEmpty(formattedEvent.status) ? '' : formattedEvent.status.replace(/ /g, "-").toLowerCase();
    let statusBadge = 'primary';

    if (statusClass === 'failed') {
      statusBadge = 'danger';
    } else if (statusClass === 'posted' || statusClass === 'partial') {
      statusBadge = 'success';
    } else if (statusClass === 'incomplete' ) {
      statusBadge = 'warning';
    } else if (statusClass === 'date-in-past') {
      statusBadge = 'light';
    }else if (statusClass === 'not-approved') {
      statusBadge = 'warning';
    } else if (statusClass === 'approved-&-scheduled') {
      statusBadge = 'success';
    } else if (statusClass === 'approved') {
      statusBadge = 'success';
    } else if (statusClass === 'scheduled') {
      statusBadge = 'success';
    }


    return statusBadge;
  }

  static formattedData(app, event) {

    const approvalMode = app.calendar.has_collaborator;

    const formattedEvent = {...event};
    formattedEvent.name = _.isEmpty(event.name) ? `Post #${event.id}` : event.name;

    const currentTime = new Date();
    const eventTime = new Date(event.d);
    formattedEvent.schedulable = event.status !== this.UN_SCHEDULED || eventTime > currentTime;

    const postStatus = formattedEvent.schedulable ? event.status : this.DATE_IN_PAST;
    if (approvalMode) {
      formattedEvent.status = this.getPostStatus(event, postStatus);
    } else {
      formattedEvent.status = postStatus;
    }

    const userTimeZone = app.apis.user.get().timezone;
    Object.assign(formattedEvent, this.formatPostTime(event, userTimeZone));

    if (!app.isEmpty(event.networks)) {
      formattedEvent.networks = this.formatNetworks(event.networks || []);
    }

    const statusClass = app.isEmpty(formattedEvent.status) ? '' : formattedEvent.status.replace(/ /g, "-").toLowerCase();


    // Additional processing for UI display
    const additionalUIFields = {
      approvalMode: approvalMode, // if calendar is in approval mode
      approvalSystem: app.approvalSystem, // if a collaborator has logged in
      statusClass: statusClass,
      statusBadge: PostFormatter.getStatusBadge(app, formattedEvent),
      pro: event.pro || event.image,
      proplus: event.proplus || event.image,
      link: event.segments === 'article' ? event.addl_data.link : '',
      segments: _.isObject(event.segments) ? 'aimi' : event.segments,

    };
    Object.assign(formattedEvent, additionalUIFields);

    if (formattedEvent.status === 'Partial') {
      formattedEvent.status = 'Posted/Rescheduled';
    }

    // Process approved notes
    if (event.approvedStatus) {
      formattedEvent.approvedNotes = `${event.approvedStatus}${event.collaborator ? ` by <small>${event.collaborator.name}</small>` : ''}`;
      if (event.approvedStatus === 'review') {
        formattedEvent.approvedNotes = `In ${event.approvedStatus}`;
      }
    } else {
      formattedEvent.approvedNotes = '';
    }

    if (!app.isEmpty(formattedEvent.link)) {
      formattedEvent.domain = Utils.getDomain(formattedEvent.link);
    }

    formattedEvent.actionStatus = this.actionStatus(formattedEvent);
    return formattedEvent;
  }

  static actionStatus(formattedEvent) {
    const app = PreBuilt;
    if(!app.isEmpty(formattedEvent.status)) {
      const status = app.isEmpty(formattedEvent.status) ? '' : formattedEvent.status.replace(/ /g, "-").toLowerCase();
      const currentTime = new Date();
      const eventTime = new Date(formattedEvent.d);
      formattedEvent.schedulable =  eventTime > currentTime;
      const postStatus = formattedEvent.schedulable || status === 'posted' || status === 'incomplete'  || status === 'posted/rescheduled' ||  status === 'failed' ? formattedEvent.status : this.DATE_IN_PAST;
      formattedEvent.status = postStatus;
      formattedEvent.actionStatus = postStatus.replace(/\s/g, '').toLowerCase();
    } else {
      formattedEvent.actionStatus = '';
    }

    return formattedEvent.actionStatus;
  }
}